import { ControlledCustomSelect, Form } from '@sravni/cosago-react-library/lib/components';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';
import React from 'react';

import { FORM_HINTS } from 'shared/config/formHints';

import { useOptions } from 'entities/pledgeAutoForm';

export const CarEnginePower: FC<IFieldFactoryProps> = ({ type, ...props }) => {
  const { powers } = useOptions();

  return (
    <ControlledCustomSelect
      {...props}
      name={type}
      options={powers}
      icon={<Form.FormHints.Tooltip text={FORM_HINTS.carEnginePower} />}
    />
  );
};
